<template>
  <vs-prompt buttons-hidden	class="large" title="تعديل بيانات الاستاذ"
             @close="close"
             :active="active">

    <div class="vx-row mb-4">
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
            label-placeholder="اسم الأستاذ"
            name="first_name"
            data-vv-as="هذا الحقل"
            v-validate="'required|alpha_spaces'"
            v-model="formData.first_name"
            class="w-full" />

        <span class="text-danger text-sm" v-show="errors.has('first_name')">{{ errors.first('first_name') }}</span>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
            label-placeholder="اسم الأب"
            name="middle_name"
            data-vv-as="هذا الحقل"
            v-validate="'required|alpha_spaces'"
            v-model="formData.middle_name"
            class="w-full" />

        <span class="text-danger text-sm" v-show="errors.has('middle_name')">{{ errors.first('middle_name') }}</span>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
            label-placeholder="اللقب"
            name="last_name"
            data-vv-as="هذا الحقل"
            v-validate="'required|alpha_spaces'"
            v-model="formData.last_name"
            class="w-full" />

        <span class="text-danger text-sm" v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
            label-placeholder="البريد الالكتروني"
            name="email"
            data-vv-as="الحقل"
            v-validate="'required|email'"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
            v-model="formData.email"
            autocomplete="false"
            class="w-full" />

        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
            label-placeholder="رقم الهاتف"
            name="phone_number"
            data-vv-as="الحقل"
            icon-pack="feather"
            icon="icon-phone"
            icon-no-border
            v-model="formData.phone_number"
            autocomplete="false"
            class="w-full" />

        <span class="text-danger text-sm" v-show="errors.has('phone_number')">{{ errors.first('phone_number') }}</span>
      </div>
    </div>

    <vs-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="submitClicked">حفظ</vs-button>
    </div>

  </vs-prompt>
</template>

<script>

import teachersAPI from '@/api/admin/teachersAPI'

export default {
  name: 'TeacherEditForm',
  props: {
    data: {
      required: true,
      type: Object
    },
    active: {
      required: true,
      default: false,
      type: Boolean
    }
  },
  watch: {
    active(val){
      if(!val) return

      this.intiValues()
      Object.assign(this.formData, this.data)
    }
  },
  data () {
    return {
      formData:{
        first_name:'',
        middle_name:'',
        last_name:'',
        email: '',
        phone_number: null,
      },
    }
  },
  methods: {
    submitClicked(){
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.close()
          this.$emit('submit', {...this.formData})
          this.$startLoading()
          teachersAPI.update(this.data.id, this.formData)
              .then(response => {
                this.$emit('submit', Object.assign({}, this.formData))
                this.close()
                this.$notifySuccess(response.successMessage)
              })
              .catch(({errors}) => {
                Object.keys(errors).forEach(key => {
                  this.$validator.errors.add({ field: key, msg: errors[key][0] })
                })
              })
              .finally(() => this.$closeLoading())
        }
      })

    },
    close(){
      this.$emit('update:active', false)
    },
    intiValues() {
      this.formData = {
        first_name:'',
        middle_name:'',
        last_name:'',
        email: '',
        phone_number: null,
      }
      this.$validator.reset()
    },
  },
}
</script>
